import { observable, action, computed } from 'mobx';
const Validator = require('validatorjs');
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import agent from '../services/web/agent';
import AuthenticationProviderType from '../services/enums/authenticationProviderType';

class InviteUserStore {
    formErrors = [];
    formMode = '';
    @observable creatingUser;
    @observable updatingUser;
    @observable isAddUserError;
    @observable addUserErrorMessage;

    @observable inProgress;
    @observable userNameValidationMessage;
    @observable emailValidationMessage;
    @observable passwordValidationMessage;
    @observable passwordConfirmedValidationMessage;
    @observable registerErrorMessage;
    @observable isRegisterError = null;
    @observable userEditDialogForm;

    @action setUserEditDialogForm(userEditDialogForm) {

        this.userEditDialogForm = userEditDialogForm;
    }

    @computed get organizationUnitsFormComplete() {

        return this.values.teamIds && this.values.teamIds.length > 0 ? true : false;
    }

    @observable values = {
        id: null,
        firstName: '',
        lastName: '',
        userName: '',
        email: '',
        teamIds: [],
        active: true,
        localeId: '',
        roleIds: [],
        authenticationProviderId: -1,
        authenticationProviderType: '',
        authenticationProviderFormatted: '',
        tenant: '',
        twoFAExemption: false,
        accessToUi: true
    };

    validateUserName() {

        const validation = userSharedFormsValidator.validateUserName(this.values.userName);

        this.userNameValidationMessage = validation.errors.first('userName');

        this.formErrors.push(validation.errorCount);
    }

    validateEmail() {

        const validation = userSharedFormsValidator.validateEmail(this.values.email);

        this.emailValidationMessage = validation.errors.first('email');

        this.formErrors.push(validation.errorCount);
    }

    validateTeamsIds() {

        const data = {
            teamIds: this.values.teamIds.length
        };

        const rules = {
            teamIds: 'min:1'
        };
        const validation = new Validator(data, rules);
        validation.passes();
        this.formErrors.push(validation.errorCount);
    }

    @action validateInviteForm() {
        this.formErrors = [];
        this.validateUserName();
        this.validateEmail();
        this.validateTeamsIds();

        if (this.formErrors.filter(valid => valid > 0).length > 0) {
            return false;
        }

        return true;
    }

    @action validateEditForm() {

        this.formErrors = [];
        this.validateEmail();
        this.validateTeamsIds();

        if (this.formErrors.filter(valid => valid > 0).length > 0) {

            return false;
        }

        return true;
    }

    reset() {
        //todo: set the default values
        this.values.id = null;
        this.values.firstName = '';
        this.values.lastName = '';
        this.values.userName = '';
        this.values.email = '';
        this.values.password = '';
        this.values.confirmedPassword = '';
        this.values.teamIds = [];

        this.values.active = true;
        this.values.localeId = 1;
        this.values.roleIds = [];
        this.values.tenant = '';

        this.userNameValidationMessage = '';
        this.emailValidationMessage = '';
        this.registerErrorMessage = '';
        this.userProfileGoBackUrl = '';

        this.addUserErrorMessage = '';
    }

    getUserModel() {

        let user = {
            userName: this.values.userName,
            firstName: this.values.userName,
            lastName: this.values.userName,
            email: this.values.email,
            roleIds: this.values.roleIds,
            teamIds: this.values.teamIds,
            active: this.values.active,
            authenticationProviderId: 1,
            tenant: this.values.tenant
        };


        user.localeId = this.values.localeId || 1;

        return user;
    }

    @action inviteUsers() {

        this.creatingUser = true;
        this.errors = null;
        this.isAddUserError = false;
        this.addUserErrorMessage = '';

        const user = this.getUserModel();

        return agent.Users.inviteUsers(user)
            .then(() => {

                this.creatingUser = false;
                this.reset();
            })
            .catch(action((err) => {

                this.creatingUser = false;

                if (err && err.response && err.response.text) {

                    this.isAddUserError = true;
                    this.addUserErrorMessage = JSON.parse(err.response.text).Message;
                }

                throw err;
            }))
            .finally(() => {
                this.creatingUser = false;
            });
    }


    @action setUserName(userName) {
        this.values.userName = userName.trim();
    }

    @action setEmail(email) {
        this.values.email = email.trim();
    }


    @action setLocaleId(localeId) {
        this.values.localeId = localeId;
    }

    @action setRoleIds(roleIds) {
        this.values.roleIds = roleIds;
    }

    @action setRoleId(roleId) {
        this.values.roleIds = [roleId];
        this.values.roleId = roleId;
    }

    @action getRoleIds() {
        return this.values.roleIds;
    }

    @action setRoleId(roleId) {
        this.values.roleIds.push(roleId);
    }

    @action removeRoleId(roleId) {

        const index = this.values.roleIds.indexOf(roleId);

        if (index > -1) {
            this.values.roleIds.splice(index, 1);
        }
    }

    @action setTeamIds(teamIds) {

        this.values.teamIds = teamIds;
    }


    @action setIsAddUserError(isError) {

        this.isAddUserError = isError;
    }

    @action setAddUserErrorMessage(errorMessage) {

        this.addUserErrorMessage = errorMessage;
    }

    @action setAuthenticationProviderType(authenticationProviderType) {

        this.values.authenticationProviderType = authenticationProviderType;
    }

    @action setAuthenticationProviderFormatted(authenticationProviderFormatted) {

        this.values.authenticationProviderFormatted = authenticationProviderFormatted;
    }

    @action setAuthenticationProviderId(authenticationProviderId) {

        this.values.authenticationProviderId = authenticationProviderId;
    }

    @action setDefaultAuthenticationProviderType() {

        this.setAuthenticationProviderType(AuthenticationProviderType.Application);
    }

    @action isNotLocalAuthenticationType() {

        if (this.values.authenticationProviderType === '') {

            return false;
        }
        return this.values.authenticationProviderType.toLowerCase()
            !== AuthenticationProviderType.Application.toLowerCase();
    }

    @action isLocalAuthenticationType() {
        return this.values.authenticationProviderType.toLowerCase()
            === AuthenticationProviderType.Application.toLowerCase();
    }

    calulateDefaultExpirationDate() {

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const newDate = new Date(year + 3, month, day);

        return newDate;
    }

    calulateMinValidDate() {

        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const newDate = new Date(year, month, day);

        return newDate;
    }
}

export default new InviteUserStore();